import { render, staticRenderFns } from "./CardList.vue?vue&type=template&id=1ed58b2e&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"
import style0 from "./CardList.vue?vue&type=style&index=0&id=1ed58b2e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed58b2e",
  null
  
)

export default component.exports